import { createColumnHelper } from "@tanstack/react-table";
import { InventoryTanotiTable } from "../../interfaces/app_types";
import InventoryAddDeleteButton from "../../components/inventory/InventoryEditDeleteButton";
import { fontColorBasedonBg, hexToRgba } from "../funcs/common";
import InventoryHistoryButton from "../../components/inventory/InventoryHistoryButton";
import InventoryInOutButton from "../../components/inventory/InventoryInOutButton";

const columnHelper = createColumnHelper<InventoryTanotiTable>();

const getStockColors = (current: number, safety: number) => {
  const greenColor = "#28a745"; // Bootstrap success color
  const redColor = "#dc3545"; // Bootstrap danger color
  const orangeColor = "#fd7e14"; // Bootstrap warning color for medium risk
  const blackColor = "#000000"; // Black for dark backgrounds
  const yellowColor = "#ffc107"; // Bootstrap warning color
  let currentColor = "#FFFFFF"; // Default color for light backgrounds

  if (current >= safety) {
    currentColor = greenColor;
  } else if ((safety - current) / safety < 0.2) {
    currentColor = yellowColor;
  } else if ((safety - current) / safety < 0.5) {
    currentColor = orangeColor;
  } else if ((safety - current) / safety < 0.8) {
    currentColor = redColor;
  } else {
    currentColor = blackColor;
  }

  return {
    "--item-background-color": hexToRgba(currentColor, 0.7),
    "--item-color": fontColorBasedonBg(currentColor),
  };
};

const trueFalseIcons = (value: boolean) => {
  return value ? (
    <i className="d-flex justify-content-center bi bi-check-square-fill text-success"></i>
  ) : (
    <i className="d-flex justify-content-center bi bi-x-square-fill text-danger"></i>
  );
};
export const InventoryTanotiColumns = [
  columnHelper.accessor((row) => row?.part_id, {
    header: "ID",
    enableColumnFilter: false,
    cell: (props) => (
      <div
        className={`${
          props.row.original?.discontinued ? "discontinued-item-row" : ""
        }`}
      >
        {props.row.original?.part_id}
      </div>
    ),
  }),
  columnHelper.accessor((row) => row?.part_name, {
    header: "Name",
    cell: (info) => info.getValue(),
  }),
  columnHelper.accessor((row) => row?.variant, {
    id: "Variant",
    cell: (info) => info.getValue(),
  }),
  columnHelper.accessor((row) => row?.size, {
    id: "Size",
    cell: (info) => info.getValue(),
  }),
  columnHelper.accessor((row) => row?.collection, {
    id: "Collection",
    cell: (info) => info.getValue(),
  }),
  columnHelper.accessor((row) => row?.sku_code, {
    id: "SKU Code",
    cell: (info) => info.getValue(),
  }),
  columnHelper.accessor((row) => row?.rack_number, {
    id: "Rack Number",
    enableColumnFilter: false,
    cell: (info) => info.getValue(),
  }),
  columnHelper.accessor((row) => row?.part_id, {
    id: "In",
    enableColumnFilter: false,
    cell: (info) => (
      <InventoryInOutButton part_id={info.getValue()} type="in" />
    ),
  }),
  columnHelper.accessor((row) => row?.part_id, {
    id: "History",
    enableColumnFilter: false,
    cell: (props) => (
      <InventoryHistoryButton
        modalId={"#historyModal"}
        identifierId={props.getValue()}
        modalTitle={`${props.row.original?.part_name} : ${props.row.original?.sku_code}`}
      />
    ),
  }),
  columnHelper.accessor((row) => row?.part_id, {
    id: "Notes",
    enableColumnFilter: false,
    cell: (props) =>
      props.row.original?.notes ? (
        <InventoryHistoryButton
          modalId="#additionalInfoModal"
          additionalInfo={true}
          identifierId={props.getValue()}
          modalTitle={`Info: ${props.row.original?.sku_code}`}
        />
      ) : (
        <div className="d-flex justify-content-center">-</div>
      ),
  }),
  columnHelper.accessor((row) => row?.current_quantity, {
    id: "Qty",
    enableColumnFilter: false,
    cell: (info) => info.getValue(),
  }),
  columnHelper.accessor((row) => row?.safety_stock, {
    id: "Safety",
    enableColumnFilter: false,
    cell: (info) => info.getValue(),
  }),
  columnHelper.accessor(
    (row) => {
      return row?.current_quantity - row?.safety_stock;
    },
    {
      id: "Difference",
      enableColumnFilter: false,
      cell: (props) => (
        <div
          className="custom-color-label"
          style={
            getStockColors(
              props.row.original.current_quantity || 0,
              props.row.original.safety_stock || 0
            ) as React.CSSProperties
          }
        >
          {props.getValue()}
        </div>
      ),
    }
  ),
  columnHelper.accessor((row) => row?.part_id, {
    id: "Edit",
    enableColumnFilter: false,
    cell: (info) => (
      <InventoryAddDeleteButton part_id={info.getValue()} btnType={"edit"} />
    ),
  }),
  columnHelper.accessor((row) => row?.part_id, {
    id: "Delete",
    enableColumnFilter: false,
    cell: (info) => (
      <InventoryAddDeleteButton part_id={info.getValue()} btnType={"delete"} />
    ),
  }),
];
